import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../_services';
import { MemberService } from '../_services/member.service';

@Component({
  selector: 'app-login-by-token',
  templateUrl: './login-by-token.component.html',
  styleUrls: ['./login-by-token.component.scss']
})
export class LoginByTokenComponent implements OnInit {
  code = "";
  memberId ;
  currentProductId: number ;
  constructor(private activatedRoute: ActivatedRoute,
    private apiService: ApiService,
    private memberService: MemberService,
    private router: Router
    ) {

    this.code = this.activatedRoute.snapshot.queryParams.code;
    this.memberId = this.activatedRoute.snapshot.queryParams.memberId;
    this.currentProductId = this.activatedRoute.snapshot.queryParams.productId;
    if(this.code){
      //localStorage.setItem('openIdTokenParams', this.token);
      // this.apiService.me().subscribe(r=>{
      //   console.log(r);
      // })

      this.apiService.loginFromAdmin(this.memberId, this.code, this.currentProductId).subscribe(r=>{
        localStorage.removeItem('currentMember');
        localStorage.setItem('openIdTokenParams', JSON.stringify(r));
        this.memberService.isLoggedin = true;
        this.router.navigateByUrl('/');

      },err=>{
        this.router.navigateByUrl('/login');
      })
    }

   }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/login-by-token/login-by-token.component.ts